import React from "react"
import { useParams } from "react-router-dom"
import HeaderSection from "../../components/header-section"
import Sidebar from "../../features/sidebar/components/sidebar"
import TutorialBuilder from "../../features/tutorial/builder/tutorial-builder"

const SimTutorialBuilderPage: React.FC = () => {
  const { simId } = useParams<{ simId: string }>()
  const testId = Number(simId)

  return (
    <div className="flex bg-[#F9FAFB] min-h-screen w-full overflow-hidden">
      <Sidebar />
      <div className="flex flex-col flex-1 overflow-hidden">
        <HeaderSection />
        <main className="flex-1 overflow-hidden">
          {Number.isFinite(testId) && testId > 0 ? (
            <TutorialBuilder testId={testId} />
          ) : (
            <div className="p-6 text-red-600">Invalid simulation id</div>
          )}
        </main>
      </div>
    </div>
  )
}

export default SimTutorialBuilderPage
